import React from 'react'
import { AnchorsOfForms } from '@constants/forms'
import { Button } from '@shared/components/button'
import { scrollToApplicationForm } from '@shared/components/forms/application/cross'
import { Image } from '@shared/components/image'
import { useSelectDevice } from '@shared/hooks/use-select-device'
import cx from 'classnames'
import Link from 'next/link'
import styled from 'styled-components'

import styles from './style.module.scss'

interface Offer {
	id: string
	title: string
	img: any
	texts: string[]
	isDraft?: boolean | undefined
	buttonText?: string | undefined
	buttonLink?: string | undefined
	buttonOnClick?: (...args: any[]) => any
}

const offers: Offer[] = [
	{
		id: 'apartment',
		title: 'Кредит под залог квартиры',
		img: {
			mobile: 'loanApartmentNew.png',
			desktop: 'loanApartmentNew.png',
			largeDesktop: 'loanApartmentNew.png',
			default: 'loanApartmentNew.png',
		},
		texts: ['Без страховок и скрытых комиссий', 'Любая кредитная история', 'Одобрение за 1 день'],
		buttonText: 'Оставить заявку',
		buttonLink: `/loan#${AnchorsOfForms.application}`,
	},
	{
		id: 'car',
		title: 'Кредит под залог автомобиля',
		img: {
			mobile: 'loanCarNew.png',
			desktop: 'loanCarNew.png',
			largeDesktop: 'loanCarNew.png',
			default: 'loanCarNew.png',
		},
		texts: [
			'Авто и ПТС остаются у вас',
			'Не важна кредитная история',
			'Высокая вероятность одобрения',
		],
		buttonText: 'Оставить заявку',
		buttonLink: `/auto-loan#${AnchorsOfForms.application}`,
	},
	{
		id: 'consumer',
		title: 'Потребительский кредит на любые цели',
		img: {
			mobile: 'loanConsumerNew.png',
			desktop: 'loanConsumerNew.png',
			largeDesktop: 'loanConsumerNew.png',
			default: 'loanConsumerNew.png',
		},
		texts: ['Без предоставления залога', 'Быстрое оформление', 'Никаких комиссий'],
		buttonText: 'Оставить заявку',
		buttonOnClick: scrollToApplicationForm,
	},
	{
		id: 'credit',
		title: 'Кредитная карта',
		img: {
			mobile: 'creditCard.png',
			desktop: 'creditCard.png',
			largeDesktop: 'creditCard.png',
			default: 'creditCard.png',
		},
		texts: ['Льготный период — до 120 дней', 'Бесплатное обслуживание', 'Кешбэк до 30%'],
		buttonText: 'Оставить заявку',
		buttonOnClick: scrollToApplicationForm,
	},
	// {
	// 	id: 'mortgage',
	// 	title: 'Ипотека',
	// 	img: {
	// 		mobile: 'loanMortgageNew.png',
	// 		desktop: 'loanMortgageNew.png',
	// 		largeDesktop: 'loanMortgageNew.png',
	// 		default: 'loanMortgageNew.png',
	// 	},
	// 	texts: [
	// 		'Крупные суммы на покупку недвижимости',
	// 		'Новостройка, вторичка и другие объекты',
	// 		'Минимум документов',
	// 	],
	// },
]

interface CardProps {
	offer: Offer
	style: string
}

const Card = ({ style, offer }: CardProps) => {
	const { title, img, texts, buttonOnClick, isDraft, buttonLink, buttonText } = offer
	return (
		<div className={cx(styles.offer, styles[style])}>
			<div className={styles.titleWrap}>
				<h3 className={styles.title}>{title}</h3>
				<Image className={cx(styles.image)} name={useSelectDevice(img)} alt={title} />
			</div>
			<div className={styles.contentWrap}>
				<ul className={styles.list}>
					{texts.map((text: string, idx: number) => {
						return <li key={idx}>{text}</li>
					})}
				</ul>
				{!buttonLink && !buttonOnClick && (
					<Button
						disabled={isDraft}
						size='m'
						className={styles.button}
						onClick={scrollToApplicationForm}
					>
						{isDraft ? 'Скоро' : 'Узнать подробности'}
					</Button>
				)}
				{!!buttonLink && (
					<ButtonWrap>
						<Link href={buttonLink}>
							<StyledButtonLink>{buttonText || 'Узнать подробности'}</StyledButtonLink>
						</Link>
					</ButtonWrap>
				)}
				{buttonOnClick && (
					<ButtonWrap>
						<StyledButtonLink onClick={buttonOnClick}>
							{buttonText || 'Узнать подробности'}
						</StyledButtonLink>
					</ButtonWrap>
				)}
			</div>
		</div>
	)
}

export const View = () => (
	<div className={styles.offersWrapper}>
		{offers.map((offer) => (
			<Card key={offer.id} style={offer.id} offer={offer} />
		))}
	</div>
)

const ButtonWrap = styled.div(() => ({
	marginTop: 24,
}))

const StyledButtonLink = styled.div(({ theme }) => ({
	display: 'flex',
	justifyContent: 'center',
	alignItems: 'center',
	color: theme.colors.mainwhite,
	cursor: 'pointer',
	background: theme.colors.main,
	borderRadius: 8,
	fontSize: 18,
	lineHeight: 24,
	height: 56,
	width: 'auto',

	':hover': {
		background: theme.colors.buttonhover,
	},

	':active': {
		background: theme.colors.buttonpressed,
	},

	[theme.mediaQueries.mediaMinWidthMobile]: {
		padding: '0 12px 1px',
	},
}))
